import { forwardRef } from 'react';
import clsx from 'clsx';
import styles from './Pill.module.css';

export const Pill = forwardRef(function Pill(
  { variant = 'tab', nowrap, flexNone, className, children, ...rest },
  ref,
) {
  return (
    <span
      ref={ref}
      className={clsx(
        styles.pill,
        variant === 'grey' && styles.variantGrey,
        nowrap && styles.nowrap,
        flexNone && styles.flexNone,
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  );
});
